import { useResourcesQuery } from "../../generated/graphql";
import { noop } from "../../services/utils";
import { DataProviderProps } from "../../types/types";
import DataViewProvider from "../DataViewProvider/DataViewProvider";

const ResourcesDataSource = {
    createFunc: noop,
    readFunc: useResourcesQuery,
    updateFunc: noop,
    deleteFunc: noop,
    deleteManyFunc: noop,
    updateManyFunc: noop
}

export default function ResourceProvider(props: DataProviderProps) {
    const { filterConfig } = props
    return (
        <DataViewProvider datasource={ResourcesDataSource} filterConfig={filterConfig}>
            {props.children}
        </DataViewProvider>
    )
}

